import { sendMetrics } from '@jusbrasil-web/shared-utils-events'

import { entityNoticeContactHash } from './contact-hash'
import type { EntityNoticePageKind, EntityNoticeVariant } from './params'

export type EntityNoticeStepAction = 'view' | 'click' | 'submit'

export interface EmitEntityNoticeStepEventParams {
  variant: EntityNoticeVariant
  step: string
  action: EntityNoticeStepAction
  pageKind: EntityNoticePageKind | null
  contact?: string
}

/**
 * Single emission point for `Topic.EntityNoticeFakedoor` from inside the
 * entity-notice fake-door signup (cells A/B/C, `QA2-8a`/`QA2-8b`). The
 * contact is hashed here, never in a component — Invariant 2 forbids a raw
 * e-mail or phone number ever reaching `sendMetrics`.
 */
export async function emitEntityNoticeStepEvent(
  params: EmitEntityNoticeStepEventParams
): Promise<void> {
  const { variant, step, action, pageKind, contact } = params
  const contact_hash = contact ? await entityNoticeContactHash(contact) : undefined

  await sendMetrics('Topic.EntityNoticeFakedoor', null, {
    metadata: {
      variant,
      step,
      action,
      page_kind: pageKind,
      ...(contact_hash ? { contact_hash } : {}),
    },
  })
}
